import { TExportOrderToPOSStatusResponse, EnumExportOrderToPOSSyncStatuses } from "models/new/index";

import config from "site-config";
import { fetchJSON } from "lib/fetch";

import { AccountFeatureFlags } from "constants/lisd-feature-flags";

type TParams = {
    orderId: string;
    lsidIdentity: any;
    account_type: string;
};

export const fetchExportOrderToPosStatus = ({
    orderId,
    lsidIdentity,
    account_type,
}: TParams): Promise<TExportOrderToPOSStatusResponse> => {
    const url = `${config.api}/api/v3.0/order/${orderId}/pos-sync`;

    const accountId = lsidIdentity?.accountGrants?.retail?.[0] ?? "";
    const hasFeature =
        lsidIdentity?.accountFeatures?.[accountId]?.includes(AccountFeatureFlags.LSPD_RSERIES_NUORDER_INTEGRATION) ??
        false;
    const hasGrant = lsidIdentity.accountGrants?.hasOwnProperty("retail");
    const isBuyer = account_type === "buyer";

    if (status !== EnumExportOrderToPOSSyncStatuses.success && hasGrant && hasFeature && isBuyer) {
        return fetchJSON<TExportOrderToPOSStatusResponse>(url, { method: "GET" });
    }

    return Promise.reject();
};
